<template>
  <div>
    <base-card>
      <div>
        <v-card-title v-if="!cardLoading" class="mb-n7">
          <v-row>
            <v-col class="d-flex justify-space-between flex-wrap align-center">
              <div>
                <v-btn small class="ma-2 mb-6" @click="onCancel">Clear</v-btn>
                <v-btn
                  color="primary"
                  small
                  dark
                  :loading="saveBtnLoading"
                  class="ma-2 mb-6"
                  @click="saveAdjustments"
                  >Save</v-btn
                >
              </div>

              <div style="width: 250px">
                <v-select
                  v-model="selectBranch"
                  :items="branchList"
                  item-text="name"
                  item-value="branch_id"
                  solo
                  dense
                ></v-select>
              </div>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-title>
          <v-row>
            <v-col cols="12" lg="8">Branch Ingredient</v-col>
            <v-col cols="12" lg="4"
              ><v-text-field
                class="mt-n5"
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                v-if="!cardLoading"
              ></v-text-field
            ></v-col>
          </v-row>
        </v-card-title>
        <div class="text-center" v-if="cardLoading">
          <v-progress-circular
            class="mb-16"
            :size="40"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>

        <div v-show="!cardLoading">
          <v-card flat>
            <v-card outlined>
              <v-list two-line>
                <template v-for="(item, index) in paginatedIngredients">
                  <v-list-item
                    :key="item.ingredient_company_id"
                    @click="openDialog(item)"
                    class="cursor-pointer"
                  >
                    <v-row align="center" class="w-100">
                      <!-- Avatar + Name -->
                      <v-col cols="12" md="3" class="d-flex align-center">
                        <v-list-item-avatar color="grey lighten-2" class="mr-3">
                          <span class="font-weight-bold">
                            {{ item.name.charAt(0) }}
                          </span>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title class="font-weight-medium">
                            {{ item.name }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-col>

                      <!-- Action -->
                      <v-col cols="12" sm="6" md="2">
                        <v-select
                          dense
                          outlined
                          label="Action"
                          :items="actions"
                          v-model="item.action"
                          @click.stop
                        />
                      </v-col>

                      <!-- Quantity -->
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field
                          type="number"
                          dense
                          outlined
                          label="Quantity"
                          v-model="item.adjust_qty"
                          @click.stop
                        />
                      </v-col>

                      <!-- Remark -->
                      <v-col cols="12" md="3">
                        <v-text-field
                          dense
                          outlined
                          label="Remark"
                          v-model="item.remark"
                          @click.stop
                        />
                      </v-col>

                      <!-- Stock -->
                      <v-col cols="12" md="2" class="text-md-right grey--text">
                        {{ item.stock_quantity }}
                        {{ item.unit === "each" ? "Unit" : item.unit }}
                      </v-col>
                    </v-row>
                  </v-list-item>

                  <v-divider v-if="index < paginatedIngredients.length - 1" />
                </template>
              </v-list>

              <!-- NO DATA -->
              <v-row
                v-if="paginatedIngredients.length === 0"
                class="pa-8"
                align="center"
                justify="center"
              >
                <v-icon class="mr-2" color="grey">mdi-database-off</v-icon>
                <span class="grey--text">No data</span>
              </v-row>

              <!-- PAGINATION FOOTER -->
              <v-row align="center" justify="end" class="px-4 py-2" no-gutters>
                <span class="mr-2 grey--text text--darken-1">
                  Rows per page:
                </span>

                <v-select
                  dense
                  hide-details
                  solo
                  flat
                  style="max-width: 80px"
                  :items="[5, 10, 20, 50]"
                  v-model="itemsPerPage"
                />

                <span class="mx-4 grey--text text--darken-1">
                  {{ pageStart }}-{{ pageEnd }} of {{ totalItems }}
                </span>

                <v-btn icon :disabled="page === 1" @click="page--">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>

                <v-btn icon :disabled="page === pageCount" @click="page++">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-row>
            </v-card>
          </v-card>
        </div>
      </div>
    </base-card>

    <v-dialog v-model="dialog" width="1200">
      <v-card>
        <v-card-title>
          <v-row align="center">
            <!-- TITLE -->
            <v-col cols="12" md="4">
              <div class="text-h6 font-weight-semibold mt-n3">
                Ingredient Movement
              </div>
            </v-col>

            <!-- FILTERS -->
            <v-col cols="12" md="8">
              <v-row justify="end">
                <!-- Movement Type -->

                <v-col cols="12" sm="6" md="auto">
                  <v-select
                    v-model="filters.type"
                    :items="typeOptions"
                    label="Movement Type"
                    dense
                    outlined
                    clearable
                    class="filter-select"
                  />
                </v-col>

                <!-- Time Range -->
                <v-col cols="12" sm="6" md="auto">
                  <v-select
                    v-model="filters.range"
                    :items="rangeOptions"
                    label="Time Range"
                    dense
                    outlined
                    class="filter-select"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-title v-if="filters.range === 'custom'" class="mt-n12">
          <v-row justify="end">
            <!-- FROM DATE -->
            <v-col cols="12" sm="6" md="auto">
              <!-- Excel Download Icon -->
              <v-menu
                v-model="menuFrom"
                :close-on-content-click="false"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filters.dateFrom"
                    label="From Date"
                    dense
                    outlined
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    class="filter-select"
                  />
                </template>
                <v-date-picker
                  v-model="filters.dateFrom"
                  @input="menuFrom = false"
                />
              </v-menu>
            </v-col>

            <!-- TO DATE -->
            <v-col cols="12" sm="6" md="auto">
              <v-menu v-model="menuTo" :close-on-content-click="false" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filters.dateTo"
                    label="To Date"
                    dense
                    outlined
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    class="filter-select"
                  />
                </template>
                <v-date-picker
                  v-model="filters.dateTo"
                  @input="menuTo = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-subtitle>
          <v-row justify="end">
            <div v-show="filteredMovements.length">
              <export-excel
                :data="filteredMovements"
                :fields="json_fields"
                :name="filename"
              >
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-download</v-icon>
                  </template>
                  <span>Download Movement Report</span>
                </v-tooltip>
              </export-excel>
            </div>
          </v-row>
        </v-card-subtitle>
        <v-data-table
          :headers="headers"
          :items="filteredMovements"
          :items-per-page="10"
          class="elevation-1"
        >
          <!-- Type badge -->
          <template v-slot:item.type="{ item }">
            <v-chip small :color="typeColor(item.type)" dark>
              {{ typeLabel(item.type) }}
            </v-chip>
          </template>

          <!-- source -->
          <template v-slot:item.source="{ item }">
            <span>
              {{ item.source == 0 ? "POS" : "Backend" }}
            </span>
          </template>

          <!-- Movement color -->
          <template v-slot:item.movement="{ item }">
            <span :class="movementClass(item.movement)">
              {{ item.movement }}
            </span>
          </template>

          <!-- Created date -->
          <template v-slot:item.created_at="{ item }">
            {{ formatDate(item.created_at) }}
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { BASEURL, BASESYNCURL } from "@/api/baseurl";
import axios from "axios";

export default {
  data() {
    return {
      domain: BASEURL,
      syncDomain: BASESYNCURL,
      branchList: [],
      snackbar: false,
      text: "",
      snackbarColor: "",
      timeout: 1900,
      companyID: "",
      ////////////
      actions: ["Purchase", "Extra", "Damage", "Lose", "Theft"],
      ingredients: [],
      page: 1,
      itemsPerPage: 5,
      movements: [],
      menuFrom: false,
      menuTo: false,
      filename: "",
      filters: {
        type: null,
        range: "this_month",
        dateFrom: null,
        dateTo: null,
      },

      rangeOptions: [
        { text: "Today", value: "today" },
        { text: "This Week", value: "this_week" },
        { text: "This Month", value: "this_month" },
        { text: "Custom", value: "custom" },
      ],
      headers: [
        { text: "ID", value: "ingredient_movement_id" },
        { text: "Type", value: "type" },
        { text: "Source", value: "source" },
        { text: "Movement", value: "movement" },
        { text: "Remark", value: "remark" },
        { text: "Created At", value: "created_at" },
      ],

      typeOptions: [
        { text: "Stock In", value: 0 },
        { text: "Stock Out", value: 1 },
        { text: "Make Order", value: 2 },
        { text: "Item Cancel", value: 3 },
      ],

      json_fields: {
        Id: "ingredient_movement_id",
        Type: {
          field: "type",
          callback: (value) => {
            if (value == 0) {
              return "Stock in";
            } else if (value == 1) {
              return "Stock out";
            } else if (value == 2) {
              return "Make order";
            } else if (value == 3) {
              return "Item cancel";
            }
          },
        },
        Source: {
          field: "source",
          callback: (value) => {
            if (value == 0) {
              return "POS";
            } else if (value == 1) {
              return "Backend";
            }
          },
        },
        Movement: "movement",
        Remark: "remark",
        Created_at: {
          field: "created_at",
          callback: (value) => {
            if (value) {
              return this.formatDate(value);
            }
          },
        },
      },
      saveBtnLoading: false,
      dialog: false,
      selectBranch: "",
      cardLoading: true,
      search: "",
    };
  },

  mounted() {
    this.ingredients = this.ingredients.map((i) => ({
      ...i,
      action: null, // dropdown value
      adjust_qty: null, // quantity input
      remark: "", // remark input
    }));
  },
  watch: {
    selectBranch() {
      this.getAllBranchIngredient();
      this.cardLoading = true;
    },
    itemsPerPage() {
      this.page = 1;
    },

    search() {
      this.page = 1;
    },

    "filters.range"(val) {
      const today = new Date();
      const format = (d) => d.toISOString().slice(0, 10);

      if (val === "today") {
        const t = format(today);
        this.filters.dateFrom = t;
        this.filters.dateTo = t;
      }

      if (val === "this_week") {
        const start = new Date(today);
        start.setDate(today.getDate() - today.getDay());
        this.filters.dateFrom = format(start);
        this.filters.dateTo = format(today);
      }

      if (val === "this_month") {
        const start = new Date(today.getFullYear(), today.getMonth(), 1);
        this.filters.dateFrom = format(start);
        this.filters.dateTo = format(today);
      }

      if (val === "custom") {
        this.filters.dateFrom = null;
        this.filters.dateTo = null;
      }
    },
  },

  computed: {
    // 1️⃣ Filter by search
    filteredIngredients() {
      if (!this.search) return this.ingredients;

      const keyword = this.search.toLowerCase();

      return this.ingredients.filter(
        (item) =>
          item.name.toLowerCase().includes(keyword) ||
          item.description.toLowerCase().includes(keyword) ||
          item.unit.toLowerCase().includes(keyword)
      );
    },

    // 2️⃣ Pagination count (based on filtered list)
    totalItems() {
      return this.filteredIngredients.length;
    },

    pageCount() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },

    pageStart() {
      return this.totalItems === 0
        ? 0
        : (this.page - 1) * this.itemsPerPage + 1;
    },

    pageEnd() {
      const end = this.page * this.itemsPerPage;
      return end > this.totalItems ? this.totalItems : end;
    },

    // 3️⃣ Paginated result (FINAL list)
    paginatedIngredients() {
      const start = (this.page - 1) * this.itemsPerPage;
      return this.filteredIngredients.slice(start, start + this.itemsPerPage);
    },

    filteredMovements() {
      return this.movements.filter((item) => {
        // Type filter
        if (this.filters.type !== null && item.type !== this.filters.type) {
          return false;
        }

        const itemDate = item.created_at.split(" ")[0];

        // Date from
        if (this.filters.dateFrom && itemDate < this.filters.dateFrom) {
          return false;
        }

        // Date to
        if (this.filters.dateTo && itemDate > this.filters.dateTo) {
          return false;
        }

        return true;
      });
    },
  },

  created() {
    var CryptoJS = require("crypto-js");
    var x = localStorage.getItem("userInfo");
    // Decrypt
    var bytes = CryptoJS.AES.decrypt(x, "secret key 123");
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    this.companyID = decryptedData.company_id;
    this.getCompanyBranch();
  },

  methods: {
    saveAdjustments() {
      this.saveBtnLoading = true;
      // Filter only rows where user actually entered data
      const payload = this.ingredients
        .filter((item) => item.action && item.adjust_qty) // only include filled rows
        .map((item) => ({
          ingredient_company_id: item.ingredient_company_id,
          action: item.action,
          quantity: item.adjust_qty,
          remark: item.remark,
        }));
      console.log(payload);

      const params = new URLSearchParams();
      params.append("adjustStock", "done");
      params.append("company_id", this.companyID);
      params.append("branch_id", this.selectBranch);
      params.append("selectedIngredient", JSON.stringify(payload));
      axios({
        method: "post",
        url: this.domain + "/ingredient/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.onCancel();
            this.dialog = false;
            this.text = "Successfully add";
            this.snackbar = true;
            this.snackbarColor = "success";
            this.saveBtnLoading = false;
            this.getAllBranchIngredient();
            this.sendNoticationForSpecificBranch(this.selectBranch);
          } else {
            this.text = "Please try again later";
            this.snackbar = true;
            this.snackbarColor = "error";
            this.saveBtnLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    typeLabel(type) {
      return ["Stock In", "Stock Out", "Make Order", "Item Cancel"][type];
    },

    typeColor(type) {
      return ["green", "red", "blue", "grey"][type];
    },

    movementClass(movement) {
      return movement.startsWith("+") ? "text--success" : "text--error";
    },

    formatDate(dateTime) {
      return dateTime ? dateTime.split(" ")[0] : "-";
    },

    onCancel() {
      this.paginatedIngredients.forEach((item) => {
        item.action = null;
        item.adjust_qty = null;
        item.remark = "";
      });

      this.page = 1;
      this.search = "";
    },

    getAllBranchIngredient() {
      const params = new URLSearchParams();
      params.append("getAllBranchIngredientEdit", "done");
      params.append("branch_id", this.selectBranch);
      params.append("company_id", this.companyID);

      axios({
        method: "post",
        url: this.domain + "/ingredient/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.ingredients = response.data.ingredient;
            this.cardLoading = false;
          } else {
            this.ingredients = [];
            this.cardLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    openDialog(item) {
      this.dialog = true;
      this.filename = item.name + "_movement_report.xls";
      const params = new URLSearchParams();
      params.append("getAllIngredientMovement", "done");
      params.append("branch_id", this.selectBranch);
      params.append(
        "ingredient_company_link_branch_id",
        item.ingredient_company_link_branch_id
      );

      axios({
        method: "post",
        url: this.domain + "/ingredient/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.movements = response.data.ingredient;
          } else {
            this.movements = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCompanyBranch() {
      const params = new URLSearchParams();
      params.append("getCompanyBranch", "done");
      params.append("company_id", this.companyID);

      axios({
        method: "post",
        url: this.domain + "/branch/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.branchList = response.data.branch;
            this.selectBranch = this.branchList[0].branch_id;
          } else {
            console.log("no list get");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sendNotication() {
      for (let i = 0; i < this.branchList.length; i++) {
        const params = new URLSearchParams();
        params.append("send_notification", "done");
        params.append("branch_id", this.branchList[i].branch_id);
        params.append("type", "1");

        axios({
          method: "post",
          url: this.syncDomain + "/sync/index.php",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.status == "1") {
              console.log("Send Notification successfully");
            } else {
              console.log("Send Notification fail");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    sendNoticationForSpecificBranch(branch_id) {
      const params = new URLSearchParams();
      params.append("send_notification", "done");
      params.append("branch_id", branch_id);
      params.append("type", "1");

      axios({
        method: "post",
        url: this.syncDomain + "/sync/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            console.log("Send Notification successfully");
          } else {
            console.log("Send Notification fail");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
.stock-cell {
  display: flex;
  align-items: center; /* vertically center */
  justify-content: center;
  min-width: 150px; /* keeps column width stable */
}
.cursor-pointer {
  cursor: pointer;
}
.pagination-footer {
  font-size: 13px;
}
.stock-field {
  margin: 0; /* remove extra margin */
  padding: 0;
  height: 36px; /* match row height */
}

.filter-select {
  width: 100%;
}

@media (min-width: 960px) {
  .filter-select {
    max-width: 180px;
  }
}
</style>